// Themed SVG illustrations for the three landing cards.
// Self-contained SMIL animations — no external CSS needed.

export const AdultsArt = () => (
  <svg viewBox="0 0 300 230" className="w-full h-full" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
    <g>
      <animateTransform attributeName="transform" type="translate" values="0 0; 0 -6; 0 0" dur="5s" repeatCount="indefinite" />
      {/* Editor window */}
      <g transform="rotate(-4 150 110)">
        <rect x="42" y="34" width="216" height="150" rx="14" fill="#141417" stroke="#33333a" strokeWidth="1.5" />
        {/* Title bar */}
        <path d="M42 48 a14 14 0 0 1 14 -14 h188 a14 14 0 0 1 14 14 v14 h-216 z" fill="#1c1c21" />
        <circle cx="60" cy="48" r="4.5" fill="#ff5f57" />
        <circle cx="76" cy="48" r="4.5" fill="#febc2e" />
        <circle cx="92" cy="48" r="4.5" fill="#28c840" />
        <rect x="150" y="42" width="70" height="12" rx="6" fill="#26262c" />
        {/* Code lines */}
        <rect x="60" y="76" width="52" height="8" rx="4" fill="#f59e0b" />
        <rect x="118" y="76" width="72" height="8" rx="4" fill="#3f3f46" />
        <rect x="74" y="94" width="94" height="8" rx="4" fill="#52525b" />
        <rect x="174" y="94" width="40" height="8" rx="4" fill="#8b5cf6" opacity="0.9" />
        <rect x="74" y="112" width="56" height="8" rx="4" fill="#34d399" opacity="0.85" />
        <rect x="136" y="112" width="80" height="8" rx="4" fill="#3f3f46" />
        <rect x="60" y="130" width="34" height="8" rx="4" fill="#f59e0b" opacity="0.7" />
        <rect x="100" y="130" width="100" height="8" rx="4" fill="#33333a" />
        <rect x="74" y="148" width="66" height="8" rx="4" fill="#52525b" />
        {/* Blinking cursor */}
        <rect x="146" y="146" width="3" height="12" rx="1.5" fill="#f59e0b">
          <animate attributeName="opacity" values="1;0;1" dur="1.1s" repeatCount="indefinite" />
        </rect>
      </g>
      {/* Floating tag chip */}
      <g transform="rotate(6 252 66)">
        <animateTransform attributeName="transform" type="translate" values="0 0; 0 -9; 0 0" dur="4s" repeatCount="indefinite" additive="sum" />
        <rect x="224" y="46" width="56" height="30" rx="10" fill="#f59e0b" />
        <text x="252" y="66" textAnchor="middle" fontFamily="monospace" fontSize="15" fontWeight="700" fill="#000">{"</>"}</text>
      </g>
      {/* Terminal prompt chip */}
      <g>
        <animateTransform attributeName="transform" type="translate" values="0 0; 0 7; 0 0" dur="4.6s" repeatCount="indefinite" />
        <rect x="16" y="150" width="86" height="30" rx="10" fill="#0b0b0d" stroke="#f59e0b" strokeOpacity="0.45" strokeWidth="1.5" />
        <text x="30" y="170" fontFamily="monospace" fontSize="13" fill="#f59e0b">$ run_</text>
        <rect x="80" y="159" width="7" height="13" fill="#f59e0b">
          <animate attributeName="opacity" values="1;0;1" dur="0.9s" repeatCount="indefinite" />
        </rect>
      </g>
    </g>
  </svg>
);

export const KidsArt = () => (
  <svg viewBox="0 0 300 230" className="w-full h-full" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
    {/* Twinkling stars */}
    {[
      { x: 44, y: 42, s: 1, d: "1.8s" },
      { x: 240, y: 150, s: 0.8, d: "2.4s" },
      { x: 70, y: 150, s: 0.7, d: "2s" },
      { x: 210, y: 38, s: 0.9, d: "2.8s" },
    ].map((st, i) => (
      <g key={i} transform={`translate(${st.x} ${st.y}) scale(${st.s})`}>
        <path d="M0 -9 L2.5 -2.5 L9 0 L2.5 2.5 L0 9 L-2.5 2.5 L-9 0 L-2.5 -2.5 Z" fill="#FFE66D" stroke="#fff" strokeWidth="1">
          <animate attributeName="opacity" values="1;0.25;1" dur={st.d} repeatCount="indefinite" />
        </path>
      </g>
    ))}

    {/* Little rocket */}
    <g transform="rotate(-32 62 84)">
      <animateTransform attributeName="transform" type="translate" values="0 0; 5 -7; 0 0" dur="3.4s" repeatCount="indefinite" additive="sum" />
      <path d="M62 52 C70 62 72 78 66 92 h-8 C52 78 54 62 62 52 Z" fill="#fff" />
      <circle cx="62" cy="72" r="5" fill="#4ECDC4" />
      <path d="M58 88 L50 100 L58 96 Z" fill="#4ECDC4" />
      <path d="M66 88 L74 100 L66 96 Z" fill="#4ECDC4" />
      <path d="M59 94 Q62 108 65 94 Z" fill="#FFE66D">
        <animate attributeName="opacity" values="1;0.4;1" dur="0.5s" repeatCount="indefinite" />
      </path>
    </g>

    {/* Robot */}
    <g>
      <animateTransform attributeName="transform" type="translate" values="0 0; 0 -6; 0 0" dur="3.8s" repeatCount="indefinite" />
      {/* Antenna */}
      <line x1="163" y1="52" x2="163" y2="38" stroke="#2B2D42" strokeWidth="3.5" strokeLinecap="round" />
      <circle cx="163" cy="33" r="6" fill="#FFE66D" stroke="#2B2D42" strokeWidth="2.5">
        <animate attributeName="r" values="6;7.5;6" dur="1.6s" repeatCount="indefinite" />
      </circle>
      {/* Head */}
      <rect x="133" y="52" width="60" height="44" rx="14" fill="#fff" stroke="#2B2D42" strokeWidth="3" />
      <circle cx="152" cy="72" r="5" fill="#2B2D42">
        <animate attributeName="ry" values="5;1;5" dur="4s" repeatCount="indefinite" />
      </circle>
      <circle cx="176" cy="72" r="5" fill="#2B2D42" />
      <path d="M155 83 Q164 90 173 83" stroke="#2B2D42" strokeWidth="3" fill="none" strokeLinecap="round" />
      {/* Ears */}
      <rect x="124" y="66" width="9" height="14" rx="4" fill="#4ECDC4" stroke="#2B2D42" strokeWidth="2.5" />
      <rect x="193" y="66" width="9" height="14" rx="4" fill="#4ECDC4" stroke="#2B2D42" strokeWidth="2.5" />
      {/* Body */}
      <rect x="139" y="102" width="48" height="44" rx="12" fill="#fff" stroke="#2B2D42" strokeWidth="3" />
      <rect x="149" y="112" width="28" height="18" rx="5" fill="#4ECDC4" stroke="#2B2D42" strokeWidth="2.5" />
      <path d="M156 121 l4 4 l8 -7" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="156" cy="138" r="3" fill="#FF6B6B" />
      <circle cx="170" cy="138" r="3" fill="#FFE66D" />
      {/* Left arm (down) */}
      <path d="M139 112 Q124 118 122 132" stroke="#2B2D42" strokeWidth="6" fill="none" strokeLinecap="round" />
      <circle cx="122" cy="134" r="6" fill="#FFE66D" stroke="#2B2D42" strokeWidth="2.5" />
      {/* Right arm (waving) */}
      <g>
        <animateTransform attributeName="transform" type="rotate" values="0 187 112; 22 187 112; 0 187 112" dur="1.4s" repeatCount="indefinite" />
        <path d="M187 112 Q202 104 208 90" stroke="#2B2D42" strokeWidth="6" fill="none" strokeLinecap="round" />
        <circle cx="209" cy="87" r="6" fill="#FFE66D" stroke="#2B2D42" strokeWidth="2.5" />
      </g>
      {/* Feet */}
      <rect x="146" y="146" width="14" height="10" rx="5" fill="#2B2D42" />
      <rect x="166" y="146" width="14" height="10" rx="5" fill="#2B2D42" />
    </g>

    {/* Speech bubble */}
    <g>
      <animateTransform attributeName="transform" type="translate" values="0 0; 0 -5; 0 0" dur="3s" repeatCount="indefinite" />
      <rect x="216" y="76" width="62" height="32" rx="12" fill="#fff" />
      <path d="M222 104 L214 116 L232 108 Z" fill="#fff" />
      <text x="247" y="97" textAnchor="middle" fontFamily="monospace" fontSize="14" fontWeight="800" fill="#FF6B6B">hi!</text>
    </g>
  </svg>
);

export const CompaniesArt = () => (
  <svg viewBox="0 0 300 230" className="w-full h-full" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
    {/* Network nodes backdrop */}
    <g stroke="#8b5cf6" strokeOpacity="0.35" strokeWidth="1.5">
      <line x1="36" y1="60" x2="78" y2="96" />
      <line x1="78" y1="96" x2="46" y2="148" />
      <line x1="252" y1="44" x2="222" y2="86" />
    </g>
    {[
      { x: 36, y: 60, d: "2.2s" },
      { x: 78, y: 96, d: "3s" },
      { x: 46, y: 148, d: "2.6s" },
      { x: 252, y: 44, d: "2.8s" },
      { x: 222, y: 86, d: "2s" },
    ].map((n, i) => (
      <circle key={i} cx={n.x} cy={n.y} r="4.5" fill="#8b5cf6">
        <animate attributeName="opacity" values="0.9;0.3;0.9" dur={n.d} repeatCount="indefinite" />
      </circle>
    ))}

    {/* Analytics panel */}
    <g>
      <animateTransform attributeName="transform" type="translate" values="0 0; 0 -6; 0 0" dur="5s" repeatCount="indefinite" />
      <g transform="rotate(3 165 120)">
        <rect x="72" y="52" width="190" height="136" rx="14" fill="#15101f" stroke="#8b5cf6" strokeOpacity="0.4" strokeWidth="1.5" />
        <rect x="88" y="66" width="64" height="9" rx="4.5" fill="#8b5cf6" opacity="0.55" />
        <rect x="88" y="82" width="40" height="7" rx="3.5" fill="#3f3f46" />
        {/* Bars */}
        <rect x="92" y="140" width="20" height="32" rx="4" fill="#4c1d95">
          <animate attributeName="opacity" values="0.7;1;0.7" dur="3s" repeatCount="indefinite" />
        </rect>
        <rect x="120" y="126" width="20" height="46" rx="4" fill="#6d28d9">
          <animate attributeName="opacity" values="0.7;1;0.7" dur="3s" begin="0.4s" repeatCount="indefinite" />
        </rect>
        <rect x="148" y="112" width="20" height="60" rx="4" fill="#8b5cf6">
          <animate attributeName="opacity" values="0.7;1;0.7" dur="3s" begin="0.8s" repeatCount="indefinite" />
        </rect>
        <rect x="176" y="96" width="20" height="76" rx="4" fill="#a78bfa">
          <animate attributeName="opacity" values="0.7;1;0.7" dur="3s" begin="1.2s" repeatCount="indefinite" />
        </rect>
        {/* Trend line + arrow */}
        <path d="M96 136 L128 120 L156 104 L196 82" stroke="#c4b5fd" strokeWidth="3" fill="none" strokeLinecap="round" strokeDasharray="140">
          <animate attributeName="stroke-dashoffset" values="140;0" dur="2s" fill="freeze" repeatCount="1" />
        </path>
        <path d="M196 82 l-12 -1 M196 82 l-3 11" stroke="#c4b5fd" strokeWidth="3" strokeLinecap="round" />
        <circle cx="196" cy="82" r="5" fill="#c4b5fd">
          <animate attributeName="r" values="5;7;5" dur="1.8s" repeatCount="indefinite" />
        </circle>
        {/* Legend dots */}
        <circle cx="222" cy="70" r="4" fill="#8b5cf6" />
        <rect x="230" y="66" width="20" height="7" rx="3.5" fill="#3f3f46" />
      </g>
    </g>

    {/* Floating people/team chip */}
    <g>
      <animateTransform attributeName="transform" type="translate" values="0 0; 0 8; 0 0" dur="4.2s" repeatCount="indefinite" />
      <rect x="30" y="170" width="88" height="34" rx="12" fill="#0d0a14" stroke="#8b5cf6" strokeOpacity="0.5" strokeWidth="1.5" />
      <circle cx="50" cy="187" r="7" fill="#8b5cf6" />
      <circle cx="64" cy="187" r="7" fill="#6d28d9" />
      <circle cx="78" cy="187" r="7" fill="#4c1d95" />
      <text x="94" y="192" fontFamily="monospace" fontSize="12" fontWeight="700" fill="#a78bfa">+12</text>
    </g>
  </svg>
);
